/**
 * Adapter: delegates IPolicyEnforcement port to services/policyEnforcementEngine singleton.
 */
import {
  policyEnforcementEngine,
  type PolicyEnforcementEngine,
} from '../../../services/policyEnforcementEngine';
import type {
  IPolicyEnforcement,
  PolicyComplianceAuditResult,
} from '../../domain/ports/IPolicyEnforcement';

export class PolicyEnforcementAdapter implements IPolicyEnforcement {
  constructor(
    private readonly engine: PolicyEnforcementEngine = policyEnforcementEngine,
  ) {}

  enforcePolicies(): void {
    this.engine.enforcePolicies();
  }

  triggerComplianceAudit(policyId?: string): PolicyComplianceAuditResult {
    return this.engine.triggerComplianceAudit(policyId) as PolicyComplianceAuditResult;
  }
}